export default __webpack_public_path__ + "static/media/bear.54950b27.svg";